'use strict'
export default (val, messageError = null) => {
    if (val && val.length > 0) {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(val)) {
            return {isValid: true} 
        }
    }
    return {isValid: false, errors: [messageError?messageError:'Invalid Email must be contain @']}
}